import { render } from "./englishImproveHome.vue?vue&type=template&id=353b63e6&scoped=true"
import script from "./englishImproveHome.vue?vue&type=script&lang=js"
export * from "./englishImproveHome.vue?vue&type=script&lang=js"

import "./englishImproveHome.vue?vue&type=style&index=0&id=353b63e6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353b63e6"]])

export default __exports__